define(["underscore"], function(_) {
  function CompositeResultPropertiesEnrichmentHandler(handlers) {
    this.handlers = handlers;
  }

  _.extend(CompositeResultPropertiesEnrichmentHandler.prototype, {
    transformRequestedProperties: function(properties) {
      _.forEach(this.handlers, function(handler) {
        try {
          properties = (handler && handler.transformRequestedProperties(properties)) || properties;
        } catch (error) {
          if (console && console.warn) {
            console.warn("Handler failed to transform requested properties, skipping.", error);
          }
        }
      });
      return properties;
    },

    start: function() {
      _.forEach(this.handlers, function(handler) {
        try {
          handler && handler.start();
        } catch (error) {
          if (console && console.warn) {
            console.warn("Handler failed to strat, skipping.", error);
          }
        }
      });
    },

    result: function(resultProps, options) {
      var resultPromise = Promise.resolve(resultProps);

      _.forEach(this.handlers, function(handler) {
        // await does not work on ES5 syntax
        resultPromise = resultPromise.then(function(result) {
          try {
            if (handler && typeof handler.result === "function") {
              return handler.result(result, options);
            }
          } catch (error) {
            if (console && console.warn) {
              console.warn("Handler failed to transform result, skipping.", error);
            }
          }

          return result;
        });
      });

      return resultPromise;
    },

    end: function() {
      _.forEach(this.handlers, function(handler) {
        try {
          handler && handler.end();
        } catch (error) {
          if (console && console.warn) {
            console.warn("Handler failed to end, skipping.", error);
          }
        }
      });
    }
  });

  return CompositeResultPropertiesEnrichmentHandler;
});
